import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import mapping from './../../../assets/fe-mocks/mock-mapping.json';

@Injectable({
  providedIn: 'root',
})
export class MockDataService {
  private http = inject(HttpClient);

  mappings: Record<string, string> = mapping as Record<string, string>;

  private getSpecificityScore(pattern: string): number {
    // Higher specificity score for more specific patterns
    return pattern.replace(/\[a-f0-9-\]+/g, '').length;
  }

  private matchUrl(url: string): string | null {
    let bestMatch: { pattern: string; file: string; score: number } | null =
      null;

    for (const pattern in this.mappings) {
      const regex = new RegExp(pattern);
      if (regex.test(url)) {
        const score = this.getSpecificityScore(pattern);
        if (!bestMatch || score > bestMatch.score) {
          bestMatch = { pattern, file: this.mappings[pattern], score };
        }
      }
    }

    return bestMatch ? bestMatch.file : null;
  }

  getMockResponse(url: string): Observable<any> {
    const mockFilePath = this.matchUrl(url);

    if (mockFilePath) {
      return this.http.get('assets/fe-mocks/' + mockFilePath).pipe(
        catchError((error) => {
          console.error(
            `Could not load mock response for ${url} from ${mockFilePath}.`,
            error,
          );
          return of(null);
        }),
      );
    } else {
      return of(null);
    }
  }
}
